import { fetchPasswordRules, mParticleGetInstance } from "@treatwell/ui";
import { getDeviceId } from "@treatwell/growthbook-js";

define(function (require) {
  var RegisterForm = require("./view/register-form");

  const PageConfig = require("common/page-config");
  const _ = require("underscore");
  const isNewRegisterAPIsEnabled = _.contains(
    PageConfig.uiChannelFeatures,
    "USE_NEW_ACCOUNT_API"
  );

  if (isNewRegisterAPIsEnabled) {
    Promise.all([getDeviceId(), mParticleGetInstance()])
      .then(([deviceId, mParticle]) => {
        const currentUser = mParticle && mParticle.Identity.getCurrentUser();
        const mpId = currentUser ? currentUser.getMPID() : undefined;
        const passwordRulesPromise = fetchPasswordRules({
          language: PageConfig.languageCode,
          context: "SIGNUP",
          body: { deviceId, mpId }
        }).catch(() => Promise.resolve("APIError"));
        RegisterForm.initialize(() => {}, passwordRulesPromise);
      })
      .catch(() =>
        RegisterForm.initialize(() => {}, Promise.resolve("APIError"))
      );
  } else {
    // Initialize form
    RegisterForm.initialize();
  }
});
